<!-- Single field structure with conditional mobile dropdown wrapper -->
<div class="inline-edit-wrapper">
  <!-- Mobile dropdown wrapper (wraps the field, not replaces it) -->
  <div
    *ngIf="isMobile && !disabled && editMode === false && isContactName"
    ngbDropdown
    placement="bottom-right"
    container="body"
    class="mobile-dropdown-overlay"
  >
    <button class="mobile-dropdown-trigger" ngbDropdownToggle type="button">
      <!-- Invisible trigger button -->
    </button>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
      <button
        class="dropdown-item"
        type="button"
        *ngIf="isContactName && canViewContactDetails"
        (click)="handleMobileViewDetails($event)"
      >
        <span class="dropdown-icon" inlineSVG="/assets/svg/external.svg"></span>
        View Contact Details
      </button>
      <button
        class="dropdown-item"
        type="button"
        (click)="handleMobileEdit($event)"
      >
        <span class="dropdown-icon" inlineSVG="/assets/svg/edit.svg"></span>
        Edit
      </button>
      <button
        class="dropdown-item"
        type="button"
        *ngIf="deleteHandler"
        otConfirmClick
        [text]="deleteConfirmText"
        (confirm)="handleMobileDelete($event)"
      >
        <span
          class="dropdown-icon"
          inlineSVG="/assets/svg/close-table.svg"
        ></span>
        Remove
      </button>
    </div>
  </div>

  <!-- Single field structure for both mobile and desktop -->
  <span
    class="field-value-wrapp"
    [ngClass]="{
      'field-value-wrapp-disabled': disabled,
      'mobile-field': isMobile && !disabled,
      'desktop-field': !isMobile || disabled
    }"
    [hidden]="editMode === true"
    (click)="handleFieldClick($event)"
  >
    <!-- SINGLE content projection point -->
    <ng-content></ng-content>

    <!-- Desktop action buttons (hidden on mobile) -->
    <span class="action-buttons" *ngIf="!disabled && !isMobile">
      <a
        href=""
        class="toggle-edit"
        [ngStyle]="{ display: inline ? 'inline-block' : 'none' }"
        inlineSVG="/assets/svg/edit.svg"
      ></a>
      <a
        *ngIf="deleteHandler"
        href=""
        class="toggle-delete"
        otConfirmClick
        [text]="deleteConfirmText"
        (click)="$event.stopPropagation(); $event.preventDefault()"
        (confirm)="deleteItem($event)"
        inlineSVG="/assets/svg/close-table.svg"
        title="Delete"
      ></a>
    </span>
  </span>

  <!-- Edit mode (same for mobile and desktop) -->
  <div class="inline-edit" *ngIf="!disabled" [hidden]="editMode === false">
    <ng-content select="ot-form-container"></ng-content>
    <span
      inlineSVG="/assets/svg/succeed.svg"
      (click)="saveEdit($event)"
      class="confirm-icon"
    ></span>
    <span
      inlineSVG="/assets/svg/reject.svg"
      (click)="cancelEdit($event)"
      class="cancel-icon"
    ></span>
  </div>
</div>
